import { estimateConstants } from '../constants/actionTypes'
import * as opportunityService from '../services/consultant/opportunityService'
import { alertError } from './alertActions'

export const fetchIndividualEstimateRequest = () => ({
  type: estimateConstants.FETCH_INDIVIDUAL_ESTIMATE_REQUEST,
})

export const fetchIndividualEstimateSuccess = (
  estimate,
  estimateId,
  afterMarketAccessories
) => ({
  type: estimateConstants.FETCH_INDIVIDUAL_ESTIMATE_SUCCESS,
  estimate,
  estimateId,
  afterMarketAccessories,
})

export const fetchIndividualEstimateError = (errorMessage) => ({
  type: estimateConstants.FETCH_INDIVIDUAL_ESTIMATE_ERROR,
  errorMessage,
})

export function fetchIndividualEstimate(
  opportunityId,
  estimateId,
  headers,
  httpVerb
) {
  return (dispatch) => {
    dispatch(fetchIndividualEstimateRequest())
    return opportunityService
      .fetchIndividualEstimate(opportunityId, estimateId, headers, httpVerb)
      .then(
        (res) => {
          dispatch(
            fetchIndividualEstimateSuccess(
              res.quote,
              estimateId,
              res.afterMarketAccessories
            )
          )
        },
        (error) => {
          dispatch(fetchIndividualEstimateError(error, estimateId))
          dispatch(alertError(error))
        }
      )
  }
}
